import { useState } from "react";

import Presentation from "./presentation";

const ActionButtons = ( { onClickLike, isVideoLike, feedId, onClickCommentIcon, commentCount, likeCount } ) => {
	const [ showShareDrawer, setShowShareDrawer ] = useState ( false );

	return (
		<Presentation
			commentCount          = { commentCount }
			feedId                = { feedId }
			isVideoLike           = { isVideoLike }
			likeCount             = { likeCount }
			onClickCommentIcon    = { onClickCommentIcon }
			onClickLive           = { onClickLike }
			setShowShareDrawer    = { setShowShareDrawer }
			showShareDrawer       = { showShareDrawer }
		/>
	);
};

export default ActionButtons;